var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberTypePatientFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.90694C11 8.18896 6.36652 10.8455 6.1692 10.9552C6.11719 10.9846 6.05906 11 6 11C5.94094 11 5.88281 10.9846 5.8308 10.9552C5.63348 10.8455 1 8.18896 1 4.90694C1.00083 4.13623 1.29271 3.39735 1.8116 2.85238C2.33049 2.30741 3.03403 2.00087 3.76786 2C4.68973 2 5.49688 2.41635 6 3.12011C6.50313 2.41635 7.31027 2 8.23214 2C8.96597 2.00087 9.66951 2.30741 10.1884 2.85238C10.7073 3.39735 10.9992 4.13623 11 4.90694Z",
    fill: "#616E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberTypePatientFamily);
export default __webpack_public_path__ + "static/media/MemberTypePatientFamily.8a34bebdbb30edcbb558590ebdb23c68.svg";
export { ForwardRef as ReactComponent };